const CONSENT_KEY = 'alioune_analytics_consent';
const GA_SCRIPT_ID = 'alioune-ga4-script';

export function getAnalyticsConsent() {
  if (typeof window === 'undefined') return null;
  return window.localStorage.getItem(CONSENT_KEY);
}

export function setAnalyticsConsent(value) {
  if (typeof window === 'undefined') return;
  window.localStorage.setItem(CONSENT_KEY, value);
  window.dispatchEvent(new CustomEvent('analytics-consent-changed', { detail: value }));
}

export function openAnalyticsPreferences() {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent('analytics-consent-open'));
}

export function loadAnalytics() {
  if (typeof window === 'undefined') return false;
  if (getAnalyticsConsent() !== 'accepted') return false;

  const measurementId = process.env.REACT_APP_GA_MEASUREMENT_ID;
  if (!measurementId) return false;

  window.dataLayer = window.dataLayer || [];
  window.gtag = window.gtag || function gtag() {
    window.dataLayer.push(arguments);
  };

  if (!document.getElementById(GA_SCRIPT_ID)) {
    const script = document.createElement('script');
    script.id = GA_SCRIPT_ID;
    script.async = true;
    script.src = 'https://www.googletagmanager.com/gtag/js?id=' + encodeURIComponent(measurementId);
    document.head.appendChild(script);

    window.gtag('js', new Date());
    window.gtag('config', measurementId, {
      send_page_view: false,
      allow_google_signals: false,
      allow_ad_personalization_signals: false,
    });
  }

  return true;
}

export function trackPageView(path) {
  if (!loadAnalytics() || typeof window.gtag !== 'function') return;
  const measurementId = process.env.REACT_APP_GA_MEASUREMENT_ID;
  window.gtag('event', 'page_view', {
    page_path: path,
    page_location: window.location.href,
    page_title: document.title,
    send_to: measurementId,
  });
}

export function trackEvent(name, params = {}) {
  if (typeof window === 'undefined') return;
  if (!loadAnalytics() || typeof window.gtag !== 'function') return;
  window.gtag('event', name, params);
}
